import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {SpineGSAPWrapper} from '../animation/SpineGSAPWrapper';
import {Possessed} from "../Possessed";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class PossessedTransitionScreenView extends PIXI.Container implements StageLayer {
    protected button:ContinueButton;
    private clickCallback?:Function;

    private fsIntroAnimation:PIXI.spine.Spine;

    private sfsOutroAnimation:PIXI.spine.Spine;
    private fsOutroAnimation:PIXI.spine.Spine;
    private fsSpinTypeAnimation:PIXI.spine.Spine;

    private spinsPlayedText:PIXI.BitmapText;
    private amountWonText:PIXI.BitmapText;
    private amountWonPos:PIXI.Point = new PIXI.Point();
    private amountWonWinCapPos:PIXI.Point = new PIXI.Point();

    private bgDarken:PIXI.Sprite;

    private backgroundAnimation:PIXI.spine.Spine;

    private winCapAnimation:PIXI.spine.Spine;

    constructor(name?:string) {
        super();
        this.name = name ? name : "ExorcismTransitionScreenView";

        // Background Animation
        this.backgroundAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.BACKGROUND_ANIMATION));

        // FS Intro/Outro images and animations
        this.fsIntroAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.FS_INTRO_ANIMATION));
        this.fsIntroAnimation.position.set(360, 360);
        this.fsIntroAnimation.visible = false;

        this.sfsOutroAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/SFS_outro.json"));
        this.sfsOutroAnimation.position.set(360, 360);
        this.sfsOutroAnimation.visible = false;

        this.fsOutroAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/Fs_Outro.json"));
        this.fsOutroAnimation.position.set(360, 360);
        this.fsOutroAnimation.visible = false;

        // FS-Intro text
        const textStyle = new PIXI.TextStyle({
            fontSize: 50,
            fontFamily: "Helvetica",
            fill: "#ffffff",
            dropShadow: true,
        });

        this.spinsPlayedText = new PIXI.BitmapText('0', {
            fontName: PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 37
        });
        (<PIXI.Point>this.spinsPlayedText.anchor).set(0.5, 0.5);
        this,this.spinsPlayedText.scale.set(0.7, 0.7);
        this.spinsPlayedText.position.set(360, 515);
        this.spinsPlayedText.visible = false;

        this.fsSpinTypeAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/FS_spins.json"));
        this.fsSpinTypeAnimation.position.set(355, 350);
        this.fsSpinTypeAnimation.visible = false;

        this.amountWonText = new PIXI.BitmapText(`0`, {
            fontName: PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 60
        });
        (<PIXI.Point>this.amountWonText.anchor).set(0.5, 0.5);
        this.amountWonText.position.set(345, 425);
        this.amountWonText.scale.set(0.5, 0.5);
        this.amountWonText.visible = false;
        this.amountWonPos.copyFrom(this.amountWonText.position);
        this.amountWonWinCapPos = new PIXI.Point(360, 480);

        // WinCap
        this.winCapAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WIN_CAP_ANIMATION));
        this.winCapAnimation.position.set(360, 360);
        this.winCapAnimation.visible = false;

        // Background darken layer
        this.bgDarken = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgDarken.tint = 0x000000;
        this.bgDarken.alpha = 0.7;
        this.bgDarken.visible = false;
        this.bgDarken.anchor.set(0.5, 0.5);
        this.bgDarken.position.set(360, 360);

        //Button
        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());
        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;

        this.addChild(this.bgDarken);
        this.addChild(this.fsOutroAnimation);
        this.addChild(this.sfsOutroAnimation);
        this.addChild(this.spinsPlayedText);
        this.addChild(this.fsSpinTypeAnimation);
        this.addChild(this.winCapAnimation);
        this.addChild(this.amountWonText);
        this.addChild(this.fsIntroAnimation);
        this.addChild(this.button);
        this.alpha = 0;
        this.onResize();
    }

    onResize() {
        if (NolimitApplication.isLandscape) {
            this.button.position.set(360, 610);
        } else {
            this.button.position.set(360, NolimitApplication.screenBounds.bottom - 250);
        }

        this.bgDarken.width = NolimitApplication.screenBounds.width;
        this.bgDarken.height = NolimitApplication.screenBounds.height;
    }

    private onButtonClick() {
        this.button.enable(false);
        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        gsap.to(this.button, {duration:0.2, alpha:0});
        delete this.clickCallback;
    }

    public enableButton(cb:Function):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.clickCallback = cb;
            this.button.enable(true);
        });
        tl.add(gsap.to(this.button, {duration:0.2, alpha:1}));
        return tl;
    }

    public showFreespinsIntro():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                let skin = "necromancy"
                switch(Possessed.model.data.freeSpinType) {
                    case 3:
                        skin = "necromancy";
                        break;
                    case 4:
                        skin = "atonement";
                        break;
                    case 5:
                        skin = "beelzebub";
                        break;
                }
                this.fsIntroAnimation.skeleton.setSkinByName(skin);
                SpineGSAPWrapper.resetSpineState(this.fsIntroAnimation);
                //this.bgDarken.visible = true;
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}))
            .add(SpineGSAPWrapper.createTimeline(this.fsIntroAnimation, 0, "intro"))
            .add(() => {
                this.fsIntroAnimation.state.setAnimation(0, "introStatic", true);
            })
    }

    public showFreespinsOutro():gsap.core.Timeline {
        const winBelowStake = Possessed.model.isWinBelowStake();
        return gsap.timeline()
            .add(() => {
                let spinType = "necromancy_spins";
                switch (Possessed.model.data.freeSpinType) {
                    case 4:
                        spinType = "atonement_spins";
                        break;
                    case 5:
                        spinType = "beelzebub_spins";
                        break;
                    default:
                        break;
                }
                SpineGSAPWrapper.resetSpineState(this.fsSpinTypeAnimation);
                this.fsSpinTypeAnimation.state.setAnimation(0, spinType, true);
                if(spinType != "beelzebub_spins") {
                    SpineGSAPWrapper.resetSpineState(this.fsOutroAnimation);
                    this.fsOutroAnimation.state.setAnimation(0, "fs_outro", true);
                } else {
                    SpineGSAPWrapper.resetSpineState(this.sfsOutroAnimation);
                    this.sfsOutroAnimation.state.setAnimation(0, "sfs_outro", true);
                }
            })
            .add(() => {
                this.spinsPlayedText.text = `${Possessed.model.gameData.numberOfFreespinsPlayed}`;
                this.spinsPlayedText.visible = true;
                
                this.amountWonText.text = SlotGame.apiPlugin.currency.formatValue(Possessed.model.gameData.accumulatedRoundWin);
                this.amountWonText.visible = true;
                this.bgDarken.visible = true;
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}))
    }

    public hideIntroOutro(fadeDuration:number=0.5):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this, {alpha: 0, duration: fadeDuration}))
            .add(() => {
                this.fsIntroAnimation.visible = false;
                this.fsOutroAnimation.visible = false;
                this.fsSpinTypeAnimation.visible = false;
                this.sfsOutroAnimation.visible = false;
                this.spinsPlayedText.visible = false;
                this.amountWonText.visible = false;
                this.winCapAnimation.visible = false;
                this.bgDarken.visible = false;
                this.amountWonText.position.copyFrom(this.amountWonPos);
            })
    }
    public instantHideIntroOutro():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.alpha = 0;
                this.fsIntroAnimation.visible = false;
                this.fsOutroAnimation.visible = false;
                this.fsSpinTypeAnimation.visible = false;
                this.sfsOutroAnimation.visible = false;
                this.spinsPlayedText.visible = false;
                this.amountWonText.visible = false;
                this.winCapAnimation.visible = false;
                this.bgDarken.visible = false;
                this.amountWonText.position.copyFrom(this.amountWonPos);
            })
    }

    public showWinCap():gsap.core.Timeline {
        return gsap.timeline()
            .add(()=> {
                SpineGSAPWrapper.resetSpineState(this.winCapAnimation);
            })
            .add(gsap.to(this, {alpha: 1, duration: 0.5}))
            .add(SpineGSAPWrapper.createTimeline(this.winCapAnimation, 0, "animation"), "<")
            .add(() => {
                this.winCapAnimation.state.setAnimation(0, "idle", true);
            })
    }
}